import { LISTING_STATE_DRAFT } from './types';
import {
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
} from './urlHelpers';

export const getEditProfileListingLinkProperties = listing => {
  if (!listing) {
    return {
      name: 'NewListingPage',
      params: {},
    };
  }

  const id = listing.id.uuid;
  const slug = createSlug(listing.attributes.title);
  const isDraft = listing.attributes.state === LISTING_STATE_DRAFT;
  const type = isDraft ? LISTING_PAGE_PARAM_TYPE_DRAFT : LISTING_PAGE_PARAM_TYPE_EDIT;

  const tab = 'details';
  return {
    name: 'EditListingPage',
    params: {
      id,
      slug,
      type,
      tab,
    },
  };
};
